var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === _vm.names.SURVEYS.STAGE.LIST)?_c('List'):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }